import React__default from 'react';
import { n as noop } from '../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';

const defaultContextValue = {
  handleRadioChange: noop,
  name: '',
  isGroupDisabled: undefined,
  isGroupInline: undefined,
  selectedValue: undefined
};
const RadioGroupContext = /*#__PURE__*/React__default.createContext(defaultContextValue);
// Internal use only (RadioGroup & Dropdown)
const RadioGroupProvider = ({
  handleRadioChange,
  isGroupInline,
  isGroupDisabled,
  name,
  selectedValue,
  children
}) => /*#__PURE__*/React__default.createElement(RadioGroupContext.Provider, {
  value: {
    handleRadioChange,
    isGroupInline,
    isGroupDisabled,
    name,
    selectedValue
  }
}, children);

export { RadioGroupContext as R, RadioGroupProvider as a };
//# sourceMappingURL=RadioGroupContext-CZtwmSGz.js.map
